import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md bg-white border border-[#E5E7EB] rounded-2xl p-8" data-testid="forgot-password-page">
        <div className="label-eyebrow">Forgot password</div>
        <h1 className="font-display font-black text-3xl mt-2">Reset your password</h1>
        {sent ? (
          <>
            <div className="mt-6 bg-[#064E3B] text-white rounded-xl p-5 text-center">
              <Mail className="w-10 h-10 mx-auto" />
              <p className="mt-3 font-display font-bold text-lg">Check your inbox</p>
              <p className="text-sm mt-1 opacity-90">If that email is registered, a reset link is on its way. It expires in 30 minutes.</p>
            </div>
            <Link to="/login" className="btn-outline w-full mt-6 inline-block text-center" data-testid="back-to-login">Back to sign in</Link>
          </>
        ) : (
          <>
            <p className="text-sm text-[#4B5563] mt-2">Enter your email and we'll send you a secure link to set a new password.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm font-semibold">Email</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-1 border border-[#E5E7EB] rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#D92D20]" />
              </div>
              <button data-testid="forgot-submit" type="submit" disabled={busy} className="btn-primary w-full">
                {busy ? "Sending..." : "Send reset link"}
              </button>
            </form>
            <p className="text-sm mt-6 text-center text-[#4B5563]">
              Remember your password? <Link to="/login" className="text-[#D92D20] font-semibold" data-testid="link-login">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
